<template>
  <div class="min-h-100vh bg-#1D2961">
    <div class="color-#B3C7F5 pt-40px flex justify-center text-22px font-500">关于我们</div>
    <img src="./assets/logo.png" alt="" class="w-120px h-120px mx-auto block mt-80px" />
    <div class="flex flex-col items-center fixed w-full bottom-32px">
      <div class="color-#FFF text-16px">勤学云（上海）科技有限公司</div>
      <div class="color-#FFF text-14px mt-8px">Qinxue Cloud (Shanghai) Technology Co., Ltd.</div>
    </div>
  </div>
</template>
